// extracted by extract-css-chunks-webpack-plugin
module.exports = {"story__cont":"_3oYGbg","story-image__cont":"a3K_n7","story-image__overlay":"_3DcvjR","story-body__cont":"XqmWn-","story-title":"_22DGMM"};